import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const pageBreakStyle = style({
  height: `calc(${theme.spacings.xs} + ${theme.borderRadiuses.s})`,
  width: "100%",
  backgroundColor: theme.colors.navigation,
  position: "relative",
  zIndex: 3,
  selectors: {
    "&:before": {
      position: "absolute",
      content: '""',
      height: theme.borderRadiuses.s,
      width: "100%",
      left: 0,
      backgroundColor: theme.colors.backgroundTint,
      top: 0,
      borderBottomLeftRadius: theme.borderRadiuses.s,
      borderBottomRightRadius: theme.borderRadiuses.s,
    },
  },
});

export const pageBreakFooterStyle = style({
  height: theme.borderRadiuses.s,
  width: theme.borderRadiuses.s,
  backgroundImage: `radial-gradient(circle at center, transparent 70%, ${theme.colors.navigation} 70%)`,
  backgroundSize: "200% 200%",
  position: "absolute",
  bottom: `calc(${theme.borderRadiuses.s} * -1)`,
});

export const pageBreakFooterLeftStyle = style({
  left: 0,
});

export const pageBreakFooterRightStyle = style({
  right: 0,
  backgroundPosition: "100% 0",
});
